"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CTAButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _spinner = require("../decorators/spinner");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var CTAButton = exports.CTAButton = /*#__PURE__*/function (_React$Component) {
  _inherits(CTAButton, _React$Component);
  function CTAButton() {
    _classCallCheck(this, CTAButton);
    return _callSuper(this, CTAButton, arguments);
  }
  _createClass(CTAButton, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (!this.props.onClickAction) {
        throw new Error('onClickAction must be present');
      }
    }
  }, {
    key: "renderSpinner",
    value: function renderSpinner() {
      var textOpacityVal = this.props.spinning ? 0 : 1;
      if (this.props.spinnerColor) {
        return [/*#__PURE__*/_react.default.createElement("span", {
          style: {
            opacity: textOpacityVal
          }
        }, this.props.buttonText), /*#__PURE__*/_react.default.createElement(_spinner.SmallSpinner, {
          show: true,
          color: this.props.spinnerColor
        })];
      }
      return /*#__PURE__*/_react.default.createElement(_spinner.Spinner, null);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("button", _extends({
        id: this.props.id,
        disabled: this.props.isDisabled ? 'disabled' : '',
        onClick: this.props.onClickAction,
        className: (0, _classnames.default)('position-relative', this.props.classNameString),
        style: this.props.style || {}
      }, this.props.attributes), this.props.spinning ? this.renderSpinner() : this.props.buttonText);
    }
  }]);
  return CTAButton;
}(_react.default.Component);
CTAButton.defaultProps = {
  classNameString: 'btn btn-lg btn-primary form',
  isDisabled: true,
  spinning: false,
  buttonText: 'Submit'
};
CTAButton.propTypes = {
  id: _propTypes.default.string,
  onClickAction: _propTypes.default.func.isRequired,
  buttonText: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
  classNameString: _propTypes.default.string,
  spinnerColor: _propTypes.default.string,
  spinning: _propTypes.default.bool,
  isDisabled: _propTypes.default.bool,
  style: _propTypes.default.object,
  attributes: _propTypes.default.object
};